import React, { Component } from "react";
import { connect } from "react-redux";
import { requestCustomers } from "../actions/customerAction";
import Badge from "react-bootstrap/Badge";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import CustomerList from "../components/CustomerList";
import CustomerStats from "../components/CustomerStats";
import SearchBox from "../components/SearchBox";

const mapStateToProps = (state) => {
  return {
    customers: state.requestCustomers.customers,
    isPending: state.requestCustomers.isPending,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onSearchChange: (value) => dispatch(requestCustomers(value)),
    onRequestCustomers: (search) => dispatch(requestCustomers(search)),
  };
};

class CustomersContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: "stats",
    };
  }
  componentDidMount() {
    this.props.onRequestCustomers("");
  }

  changeDisplay = () => {
    let { display } = this.state;
    this.setState({ display: display === "stats" ? "list" : "stats" });
  };

  renderInner(props) {
    let { display } = this.state;

    if (display === "stats") {
      return <CustomerStats customers={props} />;
    } else if (display === "list") {
      return <CustomerList customers={props} />;
    }
  }
  render() {
    const { customers, onSearchChange, isPending } = this.props;

    return (
      <div className="container-fluid">
        <Navbar className="bg-primary justify-content-between">
          <Navbar.Brand>
            Customers <Badge variant="light">{customers.length}</Badge>
          </Navbar.Brand>
          <Button variant="primary" onClick={this.changeDisplay}>
            Toggle to {this.state.display === "stats" ? "List" : "Stats"}
          </Button>
          <SearchBox searchChange={onSearchChange} />
          {/* <Button onClick={(e) => onSearch(e)} variant="primary">
            Search
          </Button> */}
        </Navbar>

        {isPending ? <h1>Loading</h1> : this.renderInner(customers)}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomersContainer);
